import { ChakraBox, ChakraFlex, SkeletonLoader } from '@equip.health/ui';

const AlertsSkeleton = () => (
  <ChakraFlex data-testid="alerts-skeleton" direction="column">
    {[...Array(5)].map((_, i) => (
      <ChakraFlex
        key={i}
        padding="16px 0"
        borderTop={i > 0 ? '1px solid' : 'none'}
        borderColor="neutral.line"
        gap="14px"
        alignItems="center"
      >
        <ChakraBox borderRadius="full" overflow="hidden" flexShrink={0}>
          <SkeletonLoader
            height="40px"
            width="40px"
            id={`alerts-skeleton-avatar-${i}`}
            startColor="neutral.line"
            endColor="neutral.background.secondary"
          />
        </ChakraBox>
        <ChakraFlex direction="column" gap="6px" flex="1">
          <SkeletonLoader
            height="16px"
            width={`${55 + i * 8}%`}
            id={`alerts-skeleton-title-${i}`}
            startColor="neutral.line"
            endColor="neutral.background.secondary"
          />
          <SkeletonLoader
            height="14px"
            width={`${35 + i * 10}%`}
            id={`alerts-skeleton-description-${i}`}
            startColor="neutral.line"
            endColor="neutral.background.secondary"
          />
        </ChakraFlex>
        <SkeletonLoader
          height="14px"
          width="64px"
          id={`alerts-skeleton-age-${i}`}
          startColor="neutral.line"
          endColor="neutral.background.secondary"
        />
      </ChakraFlex>
    ))}
  </ChakraFlex>
);

export default AlertsSkeleton;
